import { Auth, IAuthToken } from '@shared/Auth';

// Used to fetch Infrakit provided and authenticated map tiles
const tileLoadFunction = async (
    imageTile: any,
    src: string,
    providerType: string,
    uuid: string,
    authToken: string) => {

    // Add auth headers
    const headers = {};
    if (providerType === "proxy" || providerType === "infrakitProvider") {
        const token: IAuthToken = await Auth.getToken()
        headers['authorization'] = `Bearer ${token.accessToken}`
    }

    // Authenticated third party map tiles are fetched from proxy server
    if (providerType === "proxy") {
        const url = new URL(src);
        const path = url.pathname;

        // Determine query params
        const existingParams = new URLSearchParams(url.search);
        const queryParams = {};
        existingParams.forEach((value, key) => {
            queryParams[key] = value;
        });
        queryParams['project_uuid'] = kuura.getProjectUuid();

        if (uuid) {
            queryParams['kuura_base_url'] = `https://${kuura.getServerDomain()}/kuura`;
            queryParams['baselayer_uuid'] = uuid;
        } else if (authToken) {
            queryParams['authToken'] = authToken;
        }

        const queryString = new URLSearchParams(queryParams).toString();

        // Final src
        const domain = kuura.AwsApiGatewayDomain();
        const proxyPath = `map-proxy/v1${path}?${queryString}`;
        src = new URL(proxyPath, domain).toString();
    }

    const response = await fetch(src, { headers });
    const blob = await response.blob();
    imageTile.getImage().src = URL.createObjectURL(blob);
};

export { tileLoadFunction }
